const Summary = () => {

    return (
        <div>
            2025년 8월 트래킹 요약 정보 <br /> <br />

            BL No. : KMTU2025HKGS001 <br />
            운송 방식 : 해상 (FCL - 40HQ) <br />
            선사 : HMM (현대상선) <br />
            화물 : 전자제품(모니터, 노트북) 350CTN <br />
            출발항 (POL) : Hong Kong (HKG) <br />
            도착항 (POD) : Los Angeles (LAX) <br />
        </div>
    )
}
export default Summary